import React from 'react';
import { Layout } from 'antd';
import { AppHeader } from './header';
import PropTypes from 'prop-types';

export function AppLayout({ children }) {
  return (
    <Layout style={{ height: '100vh' }}>
      <AppHeader />
      <Layout.Content
        style={{
          height: 'calc(100vh - 64px)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          position: 'relative',
        }}
      >
        {children}
      </Layout.Content>
    </Layout>
  );
}

AppLayout.propTypes = {
  children: PropTypes.node,
};
